import Vuex from 'vuex'
import Vue from 'vue'

import { STANDARD_LABELS, INFO_LABELS, TAXES_LABELS, BASES_LABELS } from "./constants";
import { buildStore } from "./build_store"
import { ONBOARD_ALLOWED_USERS, CONTRACTS_KPI_ALLOWED_USERS } from "@/router";

import countries from "./modules/countries";
import configuration from "./modules/configuration";
import me from "./modules/me";
import documents from "./modules/documents";
import deleted_documents from "./modules/deleted_documents";
import connector from "./modules/connector";
import accounts from "./modules/accounts";
import tutorial from "./modules/tutorial";
import permissions from './modules/permissions';
import tax_tab from "./modules/tax_tab";
import setting_repository from './modules/setting_repository';
import cru from "./modules/cru";
import dialog_contract from "./modules/dialog_contract";
import legal_contract from "./modules/legal_contract";
import dialog_payment from "./modules/dialog_payment";
import dialog_bank_rules from "./modules/dialog_bank_rules";
import kpis from "./modules/kpis";
import contracts from "./modules/contracts";
import network_drives from "./modules/network_drives";
import config from "./modules/config";
import pdf_data from "./modules/pdf_data";
import text_tags from "./modules/text_tags";
import locations from "./modules/locations";
import webhook from './modules/webhook';
import webhook_request from './modules/webhook_request';
import payment_ok_modal from './modules/payment_ok_modal';
import payment_error_modal from './modules/payment_error_modal';
import messageModal from './modules/messageModal';
import users_permissions from './modules/users_permissions';
import cookies from './modules/cookies';
import notifications from "./modules/notifications";
import axios from 'axios';
import transactions from "./modules/transactions";
import effects from "./modules/effects";
import products from "./modules/products";
import dashboard from "./modules/dashboard";

// import { getField, updateField } from 'vuex-map-fields';
import router from '@/router'
import {client, setHeaders} from "@/api/client";
import { sync_command_dispatcher, query_dispatcher } from "@/api/client"; // add async_command_dispatcher if needed
import { EmitSignalCommand } from "@/modules/signals/application/EmitSignalCommand";
import { CountEInvoiceContractQuery } from "@/modules/revenue/app/CountEInvoiceContractQuery";
// import axios from 'axios';
// import vuetify from '../plugins/vuetify';

import {Auth} from 'aws-amplify'




const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

const store = buildStore(
  { //modules
    countries,
    configuration,
    me,
    documents,
    connector,
    accounts,
    tutorial,
    cru,
    kpis,
    contracts,
    permissions,
    network_drives,
    config,
    dialog_contract,
    legal_contract,
    dialog_payment,
    dialog_bank_rules,
    tax_tab,
    setting_repository,
    pdf_data,
    deleted_documents,
    text_tags,
    locations,
    webhook,
    webhook_request,
    payment_error_modal,
    payment_ok_modal,
    messageModal,
    users_permissions,
    cookies,
    notifications,
    transactions,
    effects,
    products,
    dashboard
  },
   { //state
    router_name: '',

    // TODO: Move to documents
    currentPage: 1,
    // TODO: Move to configuration
    labels: {
      info_labels: INFO_LABELS,
      bases_labels: BASES_LABELS,
      taxes_labels: TAXES_LABELS,
      human: STANDARD_LABELS,
      human_payroll: [
        { name: "fecha", color: "indigo", text: "Fecha" },
        { name: "num_ss", color: "red", text: "Núm. SS." },
        { name: "nombre", color: "orange", text: "Nombre" },
        { name: "apellido1", color: "yellow", text: "Primer apellido" },
        { name: "apellido2", color: "green", text: "Segundo apellido" },
        { name: "sb", color: "blue", text: "Sueldo bruto" },
        { name: "total_ss", color: "purple", text: "SS Empresa" },
        { name: "dto_ss", color: "pink", text: "SS Empleado" },
        { name: "irpf", color: "brown", text: "IRPF" },
      ],
      machine: STANDARD_LABELS,
      debug: STANDARD_LABELS,
      "040_inv_number_tag": [
        { name: "<ALPHA_NUM>", color: "red", text: "AlphaNum" },
        { name: "<NUM>", color: "green", text: "Num" },
        { name: "<NEIGHBOUR>", color: "blue", text: "Neighbour" },
        { name: "<BACKGROUND>", color: "#CCCCCC", text: "Background" },
      ],
    },
    // TODO: Move to configuration module
    
    docStates: [
      { value: 'done', text: 'Contabilizado'},
      { value: 'text_detected', text: 'Texto detectado'},
      { value: 'pending_connect', text: 'Contabilizando'},
      { value: 'accounting_aplifisa_fiscal', text: 'Contabilizando (fiscal)'},
      { value: 'accounting_invoice', text: 'Contabilizando (invoice)'},
      { value: 'uploading_bucket', text: 'Cargando'},
      { value: 'pending', text: 'En proceso'},
      { value: 'pending_review', text: 'Pendiente de revisión'},
      { value: 'error_supplier_not_found', text: 'Proveedor no encontrado'},
      { value: 'error_customer_not_found', text: 'Cliente no encontrado'},
      { value: 'error_document_duplicated', text: 'Factura duplicada'},
      { value: 'error_checking_taxes', text: 'Error de validación de importes'},
      { value: 'error_creating_moves', text: 'Error de creación de asiento'},
      { value: 'error_account_connector', text: 'Error de contabilización'},
      { value: 'error_validating_moves', text: 'Error de validación de asiento'},
      { value: 'error_validating_data', text: 'Error de validación de datos'},
      { value: 'error_text_detection', text: 'Error de detección de texto'},
      { value: 'error_insufficient_balance', text: 'Error de saldo insuficiente'},
      { value: 'assigned_contract', text: 'Contrato Asignado'},
      { value: 'error_format', text: 'Error de Formato'},
      { value: 'nif_detected', text: 'NIF Detected'},
      { value: 'nif_validated', text: 'NIF Validated'},
      { value: 'data_detected', text: 'Data Detected'},
      { value: 'data_formatted', text: 'Data Formatted'},
      { value: 'data_validated', text: 'Data Validated'},
      { value: 'move_created', text: 'Move Created'},
      { value: 'move_loaded', text: 'Move Loaded'},
      { value: 'check_duplicated_ok', text: 'Invoice number checked'},
      { value: 'error', text: 'Error'},
      { value: 'split', text: 'Separando'},
      { value: 'human_annotated', text: 'Human annotated'},
      { value: 'pending_review', text: 'Pendiente de revisión'},
      { value: 'not_supported', text: 'Formato no soportado'},
      { value: 'oriented', text: 'Oriented'},
      { value: 'move_validated', text: 'Move Validated'},
      { value: 'merging', text: 'Uniendo documentos'},
      { value: 'not_simulated', text: 'No simulado'},
      
    ],
    // TODO: End
    nextLabel: null,
    search_state: '',
    // selectedText: null,
    // writing: false,
    // creating_moves: false,
    // TODO: Move to configuration
    // annotationLayer: 'human',
    // selectedLabel: null,

    // TODO: Moved to documents module
    // docId: null,
    // currentDoc: null,
    // docFetched: false,
    // TODO: End

    companies: [],
    companydbs: [],
    suppliers: [],
    customers: [],
    nstpaths: [],
    jwtToken: '',
    isLogged: 'pending', // pending, yes, no
    isLoggedPromise: null,
    session_information: '',
    tags: [],
    currentCompany: null,
    // showModalSupplier: false,
    // showModalCustomer: false,
    retentionTypes: [],
    docRetentionTypes: [
      {'value': 'no_applies', 'text': 'N/A'},
      {'value': 'retention_professional_account', 'text': 'Profesional'},
      {'value': 'retention_professional_start_act_account', 'text': 'Profesional Inicio Act.'},
      {'value': 'retention_rental_account', 'text': 'Alquiler'},
      {'value': 'retention_paycheck_account', 'text': 'Nómina'},
      {'value': 'retention_agriculture_account', 'text': 'Agricultura y ganadería'},
      {'value': 'retention_livestock_account', 'text': 'Engorde porcino'},
      {'value': 'retention_capital_account', 'text': 'Capital mobiliario'},
      {'value': 'retention_transport_account', 'text': 'Transporte'}
    ],
    automaticPaymentAccountTypes: [
      {'value': 'na', 'text': 'N/A'},
      {'value': 'y', 'text': 'Sí'},
      {'value': 'n', 'text': 'No'},
      {'value': 'm', 'text': 'Manual'}
    ],
    thirdTypeTypes: [
      {'text': 'Persona física', 'value': 'fisica'},
      {'text': 'Persona jurídica', 'value': 'juridica'}
    ],
    fetching_companydbs: false,
    dashboard_data: undefined,
    supplierRowsPerPage: 10,
    customerRowsPerPage: 10,
    projects: [],
    channels: [],
    activities: [],
    sections: [],
    departments: [],
    delegations: [],
    expens_type: [],
    income_type: [],
    zones: [],
    hasWorkingHoursContract: false,
    hasEverHadWorkingHoursContract: false,
    hasExpiredWorkingHoursContract: false,

    objectListOptions: {},
    objectListLoading: false,
    objectListBaseUrl: "",
    objectListFilters: "",
    objectListItems: [],
    objectListItemsLength: 0,
    objectListSelected: [],
    totalLengthItems: 0,

    browserFilts: "",
    browserFiltersValues: [],
    browserFunctions: [],
    user_items: [],
    menu: false,
    sellTermsDialog: false,
    show_accounting_critical_error_msg: false,

    downloadJobState: 'done',
    asyncJobId: 0,

    strange_order_fields: {
      'credit_account': 'credit_account_integer',
      'income_account': 'income_account_integer',
    },
    oauth_url:'',
    oauth_msg: 'A continuación se redireccionará a A3 Innuva para reconectar su cuenta. ¿Está seguro?',
    default_activity: undefined,
    default_channel: undefined,
    oauth_params_storage: undefined,
    exe_link: '',
  },debug,
  { //extra getters
    router() {
      return router
    },
  },
  {//extra actions
    createUI({commit, state, getters, dispatch, rootGetters})  {
      let userData = rootGetters["me/userData"];
      let permission = rootGetters["permissions/permission"];
      let ui = [
        {
          title: 'Cerrar Sesión', click: ()=>{
            commit("SET_MENU", false);
            dispatch("signOut").then(() => {
              router.replace({name: 'login'}, () => {
                window.location.reload();
              });
            })
          }
        },
      ];

      // ui.unshift({
      //   title: 'Formación', click: ()=>{
      //     commit("SET_MENU", false);
      //     window.open('https://inmatic.ai/webinar/pildoras/formulario', '_blank');
      //   }
      // });

      if (permission.general && permission.general.can_admin && 
      userData && userData.sender_docs_user_distributor_code!='docunecta' && !['glasof', 'oxigen', 'gestoriamoro'].includes(userData.white_brand_code) &&
      !userData.available_features.feature_cliente_glasof && !userData.available_features.feature_hide_invoices) {
        ui.unshift({
          title: 'Novedades',
          click: () => {
            commit("SET_MENU", false);
            window.open('https://inmatic.ai/novedades/', '_blank');
          }
        });
      }
      /*
      if (permission.general && permission.general.can_admin && userData && userData.username && userData.sender_docs_user_distributor_code!='docunecta') {
        ui.unshift({
          title: 'Formación',
          click: () => {
            commit("SET_MENU", false);
            window.open('https://inmatic.ai/recursos/formacion/?usuario=' + userData.username, '_blank');
          }
        });
      }*/
      if (userData && (userData.is_staff || (state.session_information && userData.username && state.session_information.username != userData.username) || (permission.general && permission.general.can_admin && userData.available_features && userData.available_features.feature_network_drives))&&
      !userData.available_features.feature_hide_invoices && !permission.is_employee && !permission.is_invited) {
        ui.unshift({
          title: 'Unidades de Red',
          click: () => {
            commit("SET_MENU", false);
            router.push({name: 'network-drives'});
          }
        });
      }
      if ((userData.is_staff || userData.available_features.feature_show_access_registers || (state.session_information && state.session_information.username != userData.username)) && !getters.is_mobile && !permission.is_employee && !permission.is_invited) {
        ui.unshift({
          title: 'Registro de acceso',
          click: ()=>{
            commit("SET_MENU", false);
            router.push({name: 'access-registers'});
          }
        });
      }
      if (userData.available_features.feature_backup_page && !getters.is_mobile && !permission.is_invited) {
        ui.unshift({
          title: 'Registro de backups',
          click: ()=>{
            commit("SET_MENU", false);
            router.push({name: 'backup_logs'});
          }
        });
      }
      if (userData.available_features && permission.general && permission.general.can_admin &&
        !userData.available_features.feature_hide_invoices) {
        if (userData.available_features['feature_config_locations']) {
          ui.unshift({
            title: 'Ubicaciones',
            click: () => {
              commit("SET_MENU", false);
              router.push({name: 'locations'});
            }
          });
        }
        if (userData.available_features.feature_download_client && state.exe_link) {
          ui.unshift({
            title: 'Descargar Cliente',
            click: () => {
              commit("SET_MENU", false);
              window.open(state.exe_link, '_blank');
            }
          });
        }
        if (rootGetters.got_feature('feature_config_users') && !getters.is_mobile) {
          ui.unshift({
            title: 'Usuarios',
            click: ()=>{
              commit("SET_MENU", false);
              router.push({name: 'users-permissions'});
            }
          });
        }
      }
      
      if (userData.is_staff) {   
        // ui.splice(2, 0, {
        ui.unshift({
          title: 'KPIs', click: ()=>{
            // router.push({name: 'kpis'});
            let routeData = router.resolve({name: 'kpis'});
            window.open(routeData.href, '_blank');
          }
        });

        
      }

      const i_am_loginas = state.session_information &&
          userData.username &&
          state.session_information.username &&
          (state.session_information.username != userData.username);

      if (ONBOARD_ALLOWED_USERS.includes(userData.username) && userData.is_staff && !i_am_loginas) {
        ui.unshift({
          title: 'Información Onboard', click: ()=>{
            let routeData = router.resolve({name: 'onboard-information'});
            window.open(routeData.href, '_blank');
          }
        });
      }

      if (CONTRACTS_KPI_ALLOWED_USERS.includes(userData.username) && !i_am_loginas) {
        ui.unshift({
          title: 'Contracts KPIs', click: ()=>{
            let routeData = router.resolve({name: 'contractsKPI'});
            window.open(routeData.href, '_blank');
          }
        });
      }

      // Solo mostrar Guidelines y Funcionalidades para staff de Inmatic, NO para empleados regulares
      // Excluir explícitamente a los empleados que no son administradores
      const isRegularEmployee = permission.is_employee && !permission.general.can_admin;
      if (userData && (userData.is_staff || (state.session_information && userData.username && state.session_information.username != userData.username)) && !isRegularEmployee) {
        ui.unshift({
          title: 'Funcionalidades', click: ()=>{
            let routeData = router.resolve({name: 'features'});
            window.open(routeData.href, '_blank');
          }
        });

        ui.unshift({
          title: 'Guidelines', click: ()=>{
            // router.push({name: 'kpis'});
            let routeData = router.resolve({name: 'guidelines-list'});
            window.open(routeData.href, '_blank');
          }
        });
      }
      
      const isCustomer = userData.user_role && userData.user_role.value === 'customer';
      if (permission.general && (permission.general.can_admin || isCustomer) && !getters.is_mobile &&
        (!userData.available_features.feature_hide_mis_datos || (state.session_information && userData.username && state.session_information.username != userData.username))) {
        ui.unshift({
          title: 'Mis Datos',
          click: () => {
            commit("SET_MENU", false);
            router.push({ name: 'profile' });
          }
        });
      }
      if (permission.general && (permission.general.can_admin || (permission.is_employee && permission.is_writer)) && !getters.is_mobile &&
        (!userData.available_features.feature_hide_invoices || (state.session_information && userData.username && state.session_information.username != userData.username))) {
        if(userData && userData.available_features.feature_reports){
          ui.unshift({
            title: 'Informes', click: ()=>{
              commit("SET_MENU", false);
              router.push({name: 'reports'});
            }
          });
        }

        if (permission.general && (permission.general.can_admin || permission.is_employee) &&
        !userData.available_features.feature_hide_invoices) {
          ui.unshift({
            title: 'Configuración',
            click: () => {
              commit("SET_MENU", false);
              router.push({ name: 'user-configuration' });
            }
          });
          ui.unshift({
            title: 'Cuadro Resumen Contabilidad', click: ()=>{
              commit("SET_MENU", false);
              // router.push({name: 'dashboard'});
              let routeData = router.resolve({name: 'dashboard'});
              window.open(routeData.href, '_blank');
            }
          });
        }

        if (permission.general && (permission.general.can_admin || permission.is_employee) 
        && userData.can_view_banks && userData.has_active_bank_contract &&
        (!rootGetters.got_feature('feature_hide_banks') || rootGetters.got_feature('feature_bank_csv'))) {
          ui.unshift({
            title: 'Cuadro Resumen Bancos', click: ()=>{
              commit("SET_MENU", false);
              let routeData = router.resolve({name: 'dashboard-bank'});
              window.open(routeData.href, '_blank');
            }
          });
        }
        if (!permission.is_readonly && userData.available_features && userData.available_features.feature_other_documents &&
          !userData.available_features.feature_hide_invoices){
          ui.unshift({
            title: 'Cuadro Resumen Gestor', click: ()=>{
              commit("SET_MENU", false);
              let routeData = router.resolve({name: 'dashboard-gestor'});
              window.open(routeData.href, '_blank');
            }
          });
        }
      }
      if(permission.general && permission.general.can_admin && !getters.is_mobile && !userData.available_features.feature_hide_invoices && !userData.available_features.feature_simple_company_list){
        ui.unshift({
          title: 'Mis Empresas', click: ()=>{
            commit("SET_MENU", false);
            router.push({name: 'connectors'});
          }
        });
      }else if(permission.general && permission.general.can_admin && !getters.is_mobile && userData.available_features.feature_simple_company_list){
        ui.unshift({
          title: 'Mis Empresas', click: ()=>{
            commit("SET_MENU", false);
            router.push({name: 'connectors2'});
          }
        });
      }
      if (permission.is_readonly){
        dispatch("setActivities", state.currentCompany.id);
        dispatch("setProjects", state.currentCompany.id);
        dispatch("setChannels", state.currentCompany.id);
        dispatch("setSections", state.currentCompany.id);
        dispatch("setDelegations", state.currentCompany.id);
        dispatch("setDepartments", state.currentCompany.id);
        dispatch("setExpensIncomeType", state.currentCompany.id);
      }
      commit("SET_USER_ITEMS", ui)
    },

    createUICerrarSesion({commit, state, getters, dispatch, rootGetters})  {
      let ui = [
        {
          title: 'Cerrar Sesión', click: ()=>{
            commit("SET_MENU", false);
            dispatch("signOut").then(() => {
              router.replace({name: 'login'}, () => {
                window.location.reload();
              });
            })
          }
        },
      ];
      commit("SET_USER_ITEMS", ui)
    },


    async setAfterLogged({ commit, state, getters, dispatch, rootGetters }) {
      dispatch("createUICerrarSesion");
      await dispatch('setCompanydbs');
      let cdb = await get_cdb();
      if(cdb)
        await dispatch('resetCurrentCompany',{new_company: {'id':cdb.id}});
      await dispatch("me/refreshUserData");
      if(cdb) {
        await dispatch('setZones', cdb.id);
      }
      await dispatch('setExeLink');
      let userData = rootGetters["me/userData"];
      //Aviso para usuarios bloqueados
      if (userData && userData.hasOwnProperty('blocked') && userData.blocked) {
        let msg_user_blocked = 'Usuario bloqueado temporalmente. Contacte con su asesor.';
        dispatch("messageModal/setModal", {'text': msg_user_blocked, 'showConfirmButton': false});
        dispatch("signOut");
        if(userData.hasOwnProperty('username') && state.session_information && state.session_information.hasOwnProperty('username') && state.session_information.username != userData.username) {
          let unset_loginas_params = {
            'logged_username': state.session_information.username,
            'loginas_username': userData.username,
          };
          dispatch("unsetLoginas", unset_loginas_params);
        }
      }
      let alert_about_expiry = false;
      if (getters.router.currentRoute.path == '/initial' && "about_expiry" in getters.router.currentRoute.query) {        
        alert_about_expiry = true;
      }
      else if (getters.router.currentRoute.name == 'login') {
        try {
          if (sessionStorage.getItem('inmatic_about_expiry')) {
            sessionStorage.removeItem('inmatic_about_expiry');
            alert_about_expiry = true   ;           
          }
        } catch (e) {}        
      }      
      showAlertContractIfNeeded(alert_about_expiry);
      dispatch("setChoices");
      // dispatch("setDocRetentionTypes");
      // dispatch("setAutomaticPaymentAccountTypes");
      dispatch("notifications/fetchNotifications");
      if (getters.router.currentRoute.path == '/initial'){
        if(cdb){
          if(userData.available_features.feature_hide_invoices)
            getters.router.push({'name': 'generic-document-list', 'params': { 'companydb_id': cdb.id }})
          else
            getters.router.push({'name': 'document-list', 'params': { 'companydb_id': cdb.id }})
          
        }
        else if (userData.kind == 'organization')
          getters.router.push({'name': 'connectors'});
      }
      if (userData.can_see_training_documents) {
        dispatch("documents/setIsTrainerMode", true);
      } 
      if (userData.can_debug_documents) {
        dispatch("documents/setIsDebuggerMode", true);
      } 
      
      async function get_cdb() {
        //console.log(router.currentRoute.name, 'companydb_id' in getters.router.currentRoute.params?getters.router.currentRoute.params['companydb_id']:'no id')
        let cdb;
        await wait_for_router()
        //console.log(router.currentRoute.name, 'companydb_id' in getters.router.currentRoute.params?getters.router.currentRoute.params['companydb_id']:'no id')
        
        if(getters.router.currentRoute.name != 'document-detail'){
          if ('companydb_id' in getters.router.currentRoute.params && getters.router.currentRoute.params['companydb_id']) {
            let companydb_id = getters.router.currentRoute.params['companydb_id'];
            cdb = getters.get_companydbs.find((element) => element.id == companydb_id);
          }
          if (!cdb) {
            let keyLastCompany = getters['setting_repository/keyLastCompany'];
            let lastCompany_id = getters['setting_repository/getSettings'](keyLastCompany);
            cdb = getters.get_companydbs.find((element) => element.id == lastCompany_id);
          }
          if (!cdb)
            cdb = getters.get_companydbs[0];
        }
        return cdb;
      }

      function showAlertContractIfNeeded(alert_about_expiry=false) {
        if ((userData.available_features.feature_defaulter_user || userData.available_features.feature_bank_contract_finished) && userData.available_features.feature_payment_on_inmatic && !userData.sender_docs_user_distributor_code) {
          // $route.name
          if (getters.router.currentRoute.name && !['create-upgrate-contract', 'payment-error', 'payment-ok'].includes(getters.router.currentRoute.name)) {
            dispatch("dialog_payment/openContractModal", {'msg': 'Tu contrato ha expirado o ha excedido el número máximo de documentos.', 'distributor': false, 'facturae_client': false, 'is_company_selector_visible': false, 'is_tax_data_filled': false});
          }
          // setInterval(function () {
          //   if (getters.router.currentRoute.name && !['create-upgrate-contract', 'payment-error', 'payment-ok'].includes(getters.router.currentRoute.name)) {
          //     dispatch("dialog_payment/openContractModal", 'Tu contrato ha expirado o ha excedido el número máximo de documentos.');
          //   }
          // }, 3 * 60 * 1000);
        } else if (alert_about_expiry && userData.available_features.feature_contract_is_going_to_finish && userData.available_features.feature_payment_on_inmatic) {
          dispatch("dialog_payment/openContractModal", {'msg': 'Tu contrato está a punto de expirar o de exceder el número máximo de documentos.', 'distributor': false, 'facturae_client': false, 'is_company_selector_visible': false, 'is_tax_data_filled': false});
        } else if (alert_about_expiry && userData.available_features.feature_trial_contract_is_finished && userData.available_features.feature_payment_on_inmatic) {
          dispatch("dialog_payment/openContractModal", {'msg': 'Tu contrato es de prueba, cuando expire el periodo de prueba o se excedan el número de documentos de prueba necesitarás contratar un plan.', 'distributor': false, 'facturae_client': false, 'is_company_selector_visible': false, 'is_tax_data_filled': false});
        }
      }
      //----------------------------------------------SHOULD NOT BE HERE------------------------------------------------------------
      //----------------------------------------------------------------------------------------------------------------------------
      
      // await dispatch('permissions/getPermissions', state.currentCompany.id);
      // let company = (await dispatch('connector/fetchConnector', state.currentCompany)).data;
      // commit('SET_CURRENT_COMPANY', company);
      // commit('SET_DEFAULT_ACTIVITY', state.currentCompany.configuration.actividad, { root: true })
      
      // if (userData.available_features && userData.available_features.feature_filter_by_ejercicio) {
      //   if (state.currentCompany.links.length) {
      //     let link = {
      //       'id': 0,
      //       'min_date': '1900-01-01',
      //     };
      //     for (let i in state.currentCompany.links) {
      //       if (state.currentCompany.links[i].active && state.currentCompany.links[i].min_date > link['min_date']) {
      //         link = state.currentCompany.links[i];
      //       }
      //     }
      //     if (link['id']) {
      //       dispatch("documents/setFilterDataEjercicioValue", link['id']);
      //       dispatch("documents/generateFilters");
      //     }
      //   }
      // }
      // dispatch("documents/setCurrentStateChip", false);
      // dispatch("documents/setAllCurrentsFilters", false);
      // dispatch("documents/refreshData"); 
      // dispatch("refreshData", '');
      // dispatch("createUI");
      
      // await dispatch("documents/getHeader");

      // try{     
      //   let currentDoc = rootGetters["documents/currentDocument"]
      //   if (currentDoc) {
      //     dispatch("setSuppliers", this.currentDoc.companydb);
      //     dispatch("setCustomers", this.currentDoc.companydb);
      //     dispatch("setProjects", this.currentDoc.companydb);
      //     dispatch("setChannels", this,currentDoc.companydb);
      //     dispatch("setActivities", this.currentDoc.companydb);
      //   } else {
      //     dispatch("setProjects", state.currentCompany.id);
      //     dispatch("setChannels", state.currentCompany.id);
      //     dispatch("setActivities", state.currentCompany.id);
      //   }
      // }catch(error){
      //   if (state.currentCompany) {
      //     dispatch("setProjects", state.currentCompany.id);
      //     dispatch("setChannels", state.currentCompany.id);
      //     dispatch("setActivities", state.currentCompany.id);
      //   }
      // }
      //----------------------------------------------------------------------------------------------------------------------------
      //----------------------------------------------------------------------------------------------------------------------------
      
    },

    setCompanydbs(context) {
      return new Promise((resolve, reject) => {
        context.commit('FETCHING_COMPANY_DBS', true)
        client.get('get_companydbs/').then(response => {
          let cdbs = [];
          for (let i in response.data.results) {
            if (response.data.results[i]['name'] !== null) {
              cdbs.push(response.data.results[i])
            }
          }

          context.commit('SET_COMPANY_DBS', cdbs)
          context.commit('FETCHING_COMPANY_DBS', false)
          //----------------------------------------------SHOULD NOT BE HERE------------------------------------------------------------
          //----------------------------------------------------------------------------------------------------------------------------
      
          // if (!context.state.currentCompany) {
          //   let keyLastCompany = context.getters['setting_repository/keyLastCompany'];
          //   let lastCompany = context.getters['setting_repository/getSettings'](keyLastCompany);
          //   let companydb_id;
          //   if ('companydb_id' in context.getters.router.currentRoute.params && context.getters.router.currentRoute.params['companydb_id']) {
          //     companydb_id = context.getters.router.currentRoute.params['companydb_id'];
          //   }
          //   else if ('id' in context.getters.router.currentRoute.params && context.getters.router.currentRoute.params['id']) {
          //     companydb_id = context.getters.router.currentRoute.params['id'];
          //   }
          //   else {
          //     let userData = context.rootGetters["me/userData"];
          //     if (!userData.is_staff)
          //       companydb_id = lastCompany;
          //   }
          //   context.dispatch("connector/checkCompanyApi", { company_id: companydb_id, route: context.getters.router.currentRoute.path }).then((response) => {
          //     if (response.data && response.data.type == 'redirect') {
          //       context.dispatch("setOauthUrl",{url : response.data.url})
          //     }
          //   }, function(error) {});
          //   let conep = 0;
          //   for (let i in response.data.results) {
          //     if (companydb_id && response.data.results[i].id == companydb_id) {
          //       conep = i;
          //     } 
          //   }
          //   if (response && response.data && response.data.results && response.data.results.length > 0) {
          //     context.dispatch('setCurrentCompany', response.data.results[conep]); //aaaaaaaaaa needs checking
          //     if (context.getters.router.currentRoute.path == '/initial' || context.getters.router.currentRoute.path == '/documents'){
          //       if (response.data.results && response.data.results.length > 0) {
          //       }
          //       if (response.data.results[conep]) {
          //         context.getters.router.push({'name': 'document-list', 'params': { 'companydb_id': response.data.results[conep].id }})
          //       } else {
          //         context.getters.router.push({'name': 'document-list', 'params': {'companydb_id': response.data.results[0].id}})
          //       }
          //     }
          //   } else {
          //     context.dispatch('me/refreshUserData').then(() => {
          //       let userData = context.rootGetters["me/userData"];
          //       if (userData.kind == 'organization') {
          //         context.getters.router.push({'name': 'connectors'});
          //       }
          //     });
          //   }
          // } else {
          //   for (let i in response.data.results) {
          //     if (response.data.results[i].id == context.state.currentCompany.id) {
          //       context.dispatch('setCurrentCompany', response.data.results[i])
          //     }
          //   }
          // }
          //----------------------------------------------------------------------------------------------------------------------------
          //----------------------------------------------------------------------------------------------------------------------------
      
          resolve();
        }).catch(error => { 
          reject(error)
         });
      })
    },

    setCompanydbs2(context) {
      return new Promise((resolve, reject) => {
        context.commit('FETCHING_COMPANY_DBS', true);
        client.get('get_companydbs/').then(response => {
          let cdbs = [];
          for (let i in response.data.results) {
            if (response.data.results[i]['name'] !== null) {
              cdbs.push(response.data.results[i]);
            }
          }
          context.commit('SET_COMPANY_DBS', cdbs);
          context.commit('FETCHING_COMPANY_DBS', false);
          if (!context.state.currentCompany) {
            let keyLastCompany = context.getters['setting_repository/keyLastCompany'];
            let lastCompany = context.getters['setting_repository/getSettings'](keyLastCompany);
            let companydb_id;
            if (lastCompany && !context.getters.router.currentRoute.params.companydb_id) {
              companydb_id = lastCompany;
            } else {
              companydb_id = context.getters.router.currentRoute.params.companydb_id;
            }
            let conep = 0;
            for (let i in response.data.results) {
              if (companydb_id && response.data.results[i].id == companydb_id) {
                conep = i;
              }
            }
            if (response && response.data && response.data.results && response.data.results.length > 0) {
              context.dispatch('resetCurrentCompany', {new_company:response.data.results[conep]}); 
              if (context.getters.router.currentRoute.path == '/initial' || context.getters.router.currentRoute.path == '/documents'){
                if (response.data.results && response.data.results.length > 0) {
                }
                if (response.data.results[conep]) {
                  context.getters.router.push({'name': 'document-list', 'params': { 'companydb_id': response.data.results[conep].id }})
                } else {
                  context.getters.router.push({'name': 'document-list', 'params': {'companydb_id': response.data.results[0].id}})
                }
              }
            } else {
              context.dispatch('permissions/getPermissions', companydb_id).then(() => {
                let permission = context.rootGetters["permissions/permission"];
                if (permission.can_write) {
                  context.getters.router.push({'name': 'connectors'});
                }
              });
            }
          }
          else{
            let found = false;
            for (let i in response.data.results) {
              if (response.data.results[i].id == context.state.currentCompany.id) {
                found = true;
              }
            }
            if(!found){
              context.dispatch('resetCurrentCompany', {new_company:response.data.results[0]});
            }
          }
          resolve();
        }).catch(error => { 
          reject(error)
         });
      })
    },

    async resetCurrentCompany({commit, state, dispatch, rootState, rootGetters,getters}, {new_company}) {
      dispatch("documents/setCurrentLoading", true);
      commit('SET_OBJECT_LIST_LOADING', true);
      new_company=(await dispatch('connector/fetchConnector', new_company)).data;
      await dispatch('permissions/getPermissions', new_company.id);
      let old_company = state.currentCompany;
      dispatch('setCurrentCompany', new_company);
      dispatch("createUI");
      dispatch('setProjects', new_company.id);
      dispatch('setChannels', new_company.id);
      dispatch('setActivities', new_company.id);
      dispatch('setSections', new_company.id);
      dispatch('setDelegations', new_company.id);
      dispatch('setDepartments', new_company.id);
      dispatch('setExpensIncomeType', new_company.id)
      dispatch('setZones', new_company.id);
      dispatch("documents/getHeader");
      dispatch("documents/getHeaderSupplierDBUser");
      dispatch("documents/getHeaderCustomerDBUser");
      let userData = rootGetters["me/userData"];
      let permission = rootGetters["permissions/permission"];
      let refresh_called = false;
      if (userData.available_features && userData.available_features.feature_filter_by_ejercicio) {
        if (new_company.links.length) {
          let link = {
            'id': 0,
            'min_date': '1900-01-01',
          };
          for (let i in new_company.links) {
            if (new_company.links[i].active && new_company.links[i].min_date > link['min_date']) {
              link = new_company.links[i];
            }
          }
          if (link['id']) {
            dispatch("documents/setFilterDataEjercicioValue", link['id']);
            dispatch("documents/generateFilters");
            refresh_called = true;
          }
        }
      }
      dispatch("documents/setAllCurrentsFilters", false);
      dispatch("documents/setCurrentStateChip", false);
      if (permission.can_write) {
        dispatch("connector/checkCompanyApi", {company_id: new_company.id, route: getters.router.currentRoute.path }).then((response) => {
          if (response.data && response.data.type == 'redirect') {
            dispatch("setOauthUrl",{url : response.data.url});
            dispatch("setOauthMsg", { msg: response.data.msg });
          }
        }, function(error) {});
      }
      else if (userData.can_view_e_invoice && permission.is_invited && userData.available_features['feature_buy_facturae_for_client']) {
        let result = await new CountEInvoiceContractQuery(query_dispatcher).run(true) // client = true -> for client users
        if (result > 0) {
          new EmitSignalCommand(sync_command_dispatcher).run(new_company.id)
        }
      }
      if(!refresh_called){
        dispatch("documents/refreshData");
      }
      dispatch("deleted_documents/resetDeletedDocuments")
      dispatch('refreshData');
      dispatch("documents/setCurrentLoading", false);
      commit('SET_OBJECT_LIST_LOADING', false);

      let got_feature = rootGetters["got_feature"];
      let urls_bank = ['bank-accounts', 'bank-transactions', 'create-bank-accounts'];
      if ((!got_feature('feature_can_user_bank_account') && !got_feature('feature_bank_csv')) && urls_bank.indexOf(getters.router.currentRoute.name) > -1) {
        getters.router.push({'name': 'document-list', 'params': {'companydb_id': new_company.id}});
      }
      else if (getters.router.currentRoute.name == 'bank-transactions' && old_company && new_company.id != old_company.id) {
        getters.router.push({'name': 'bank-accounts', 'params': {'company_id': new_company.id}});
      }
    },
  }
)

function init(result){
  store.dispatch('setJWTToken', result);
  store.dispatch('waitForLoggedIn').then(isLogged => {
    if (isLogged) {
      store.dispatch('setAfterLogged');
    }
  });
}

function cognitoError(error){
  console.error("Not logged in")
  store.commit('SET_IS_LOGGED','no');
  //   router.push("login");
}

async function wait_for_router(){
  // WAIT FOR ROUTER OR 2 SECONDS
  let resolved = false
  return new Promise((resolve, reject) => {
    let interval = setInterval(() => {
      if (router.history.ready && !resolved) {
        resolved = true;
        console.log("Router is ready");
        clearInterval(interval);
        resolve();
      }
    }, 100);
    setTimeout(() => {
      if (!resolved){
        resolved = true;
        clearInterval(interval);
        console.log("Router not ready after 2 seconds")
        resolve();
      }
    }, 2000);
  });
}


//   return new Promise((resolve) => {
//     let interval = setInterval(() => {
//       if (router.history.ready) {
//         clearInterval(interval);
//         resolve();
//       }
//     }, 100);
//   });

// }

store.commit('SET_IS_LOGGED_PROMISE',Auth.currentAuthenticatedUser())

store.state.isLoggedPromise.then(init,cognitoError);

export default store;
